import axios from 'axios';


interface IRequestMaker{
    get:(resource:string, params?:any, method?: string) => {} ;
    post:(resource:string, data?:any, method?: string) => {};
    patch:(resource:string, data?:any, method?: string) => {};
    put:(resource:string, data?:any, method?: string) => {};
    delete:(resource:string, param?:any, method?: string) => {};
}

class RequestMaker implements IRequestMaker{
    private baseUrl:string;
    private token:string;

    constructor(baseUrl:string, token?:string) {
        this.baseUrl = baseUrl;
        this.token = token || '';
    }

    public get(resource:string, params?:any, method?: string): Promise<any> {
        let url = this.baseUrl + resource;
        if(method){
            url += `/${method}`;
        }
        const config:any = {};
        if(this.token){
            config.headers =  {
                'token': this.token,
                'Accept': 'application/json',
            };
        }
        if (params){
            config.params = params;
        }
        return axios.get(url, config);
    }

    public post(resource:string, data?:any, method?: string): Promise<any> {
        let url = this.baseUrl + resource;
        if(method){
            url += `/${method}`;
        }
        const config :any = {};
        if(this.token){
            config.headers =  {
                'token': this.token,
                'Accept': 'application/json',
            };
        }
        return axios.post(url, data, config);
    }

    public patch(resource:string, data?:any, method?: string): Promise<any> {
        let url = this.baseUrl + resource;
        if(method){
            url += `/${method}`;
        }
        const config :any = {};
        if(this.token){
            config.headers =  {
                'token': this.token,
                'Accept': 'application/json',
            };
        }
        return axios.patch(url, data, config);
    }

    public put(resource: string, data?: any, method?: string):Promise<any>{
        let url = this.baseUrl + resource;
        if(method){
            url += `/${method}`;
        }
        const config :any = {};
        if(this.token){
            config.headers =  {
                'token': this.token,
                'Accept': 'application/json',
            };
        }
        if (data){
            config.data =  data;
        }
        return axios.put(url, data, config);
    }

    public delete(resource:string, data?:any, method?: string): Promise<any>{
        let url = this.baseUrl + resource;
        if(method){
            url += `/${method}`;
        }
        const config :any = {};
        if(this.token){
            config.headers =  {
                'token': this.token,
                'Accept': 'application/json',
            };
        }
        if (data){
            config.data =  data;
        }
        return axios.delete(url,config);
    }


    public getToken(): string {
        return this.token;
    }

    public setToken(token: string) {
        this.token = token;
    }
}

export { RequestMaker } 